import { NgModule } from '@angular/core';

import * as Prismjs from 'prismjs';
import 'prismjs/plugins/toolbar/prism-toolbar';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-sass';
import 'prismjs/components/prism-scss';
import 'prismjs/components/prism-bash';

import { PRISM } from './prism.config';

export function PrismFactory(): any {
  return () => Prismjs;
}

@NgModule({
  declarations: [],
  providers: [
    {
      provide: PRISM,
      useFactory: PrismFactory
    }
  ]
})
export class PrismModule { }
